export const autoResize = (textarea: HTMLTextAreaElement, blockName?: string) => {
  if (!textarea) return;

  // Reset height to auto to get the correct scrollHeight
  textarea.style.height = 'auto';
  
  // Calculate the new height
  const scrollHeight = textarea.scrollHeight;
  const minHeight = 32; // Minimum height in pixels
  const maxHeight = 400; // Maximum height in pixels
  const buffer = 4; // Extra space buffer
  
  // Apply height constraints
  const newHeight = Math.max(minHeight, Math.min(scrollHeight + buffer, maxHeight));
  
  // Set the new height
  textarea.style.height = `${newHeight}px`;
  
  // If content exceeds maxHeight, enable scrolling
  if (scrollHeight > maxHeight) {
    textarea.style.overflowY = 'auto';
  } else {
    textarea.style.overflowY = 'hidden';
  }
};

export const setupAutoResize = (textarea: HTMLTextAreaElement, blockName?: string) => {
  if (!textarea) return;

  // Set initial height
  autoResize(textarea, blockName);

  // Set up event listeners
  const handleInput = () => autoResize(textarea, blockName);
  const handlePaste = () => {
    // Use setTimeout to ensure content is pasted before resizing
    setTimeout(() => autoResize(textarea, blockName), 0);
  };

  textarea.addEventListener('input', handleInput);
  textarea.addEventListener('paste', handlePaste);

  // Return cleanup function
  return () => {
    textarea.removeEventListener('input', handleInput);
    textarea.removeEventListener('paste', handlePaste);
  };
};
